import React, { useContext } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";
import Select from "../../ui/Select/Select";
import Table from "../../ui/Table/Table";
import { FixedHeader, PrimaryHeader, SecondaryHeader } from "../../ui/Header";
import classnames from "classnames";
import "./Pay.scss";
import TeasersPayTable from "./TeasersPayTable";
import CommonPayTable from "./CommonPayTable";

import * as urls from "../../utils/urls";
import moment from "moment";

import GlobalsContext from "../../context/GlobalsContext";

import useSearch from "../../hooks/useSearch";

import { payoutOptions } from "../../constants";

import * as perm from "../../utils/perm";
import IfPermission from "../../components/IfPermission";

const payoutOptionsWithGrade = payoutOptions.concat([
  { label: "Оценка", value: -1 }
]);

const Pay = ({ match, location, history }) => {
  const globalsContext = useContext(GlobalsContext);

  const [search, setSearch] = useSearch(
    {
      date_from: moment().startOf("month").format("YYYY-MM-DD"),
      date_to: moment().format("YYYY-MM-DD"),
      date: moment().format("YYYY-MM-DD"),
      user: "",
      status: ""
    },
    location,
    history
  );

  const setDateRange = ({ startDate, endDate }) => {
    setSearch({
      date_from: moment(startDate).format("YYYY-MM-DD"),
      date_to: moment(endDate).format("YYYY-MM-DD")
    });
  };

  const setDate = date => {
    setSearch({ date: moment(date).format("YYYY-MM-DD") });
  };

  const onUserSelect = item => {
    setSearch({ user: item.value });
  };

  const onStatusSelect = item => {
    setSearch({ status: item.value });
  };

  return (
    <div className="page-pay">
      <FixedHeader>
        <PrimaryHeader className="x">
          <span className="header__title">Оплата</span>
          <ButtonGroup
            items={[
              { title: "Общая", code: urls.payCommon() },
              { title: "По анонсам", code: urls.payTeasers() }
            ]}
            theme="dark"
            selected="add"
            nav
          />
          <div className="page-pay__header-filters">
            <IfPermission checker={perm.canViewPayoutStatusAll}>
              <Select
                placeholder="Выбор автора"
                theme="dark"
                className="campaign"
                value={parseInt(search.user)}
                onSelect={onUserSelect}
                options={globalsContext.content_users}
                searchable
              />
            </IfPermission>

            <Route
              path={urls.payTeasers()}
              render={() => (
                <Select
                  placeholder="Статус"
                  theme="dark"
                  options={payoutOptionsWithGrade}
                  onSelect={onStatusSelect}
                  value={parseInt(search.status)}
                />
              )}
            />
          </div>
        </PrimaryHeader>
      </FixedHeader>

      <div className="content-body content-body__with-fixed">
        <Switch>
          <Redirect from={urls.pay()} to={urls.payCommon()} exact />
          <Route
            path={urls.payCommon()}
            render={() => (
              <CommonPayTable search={search} setDateRange={setDateRange} />
            )}
          />
          <Route
            path={urls.payTeasers()}
            render={() => <TeasersPayTable search={search} setDate={setDate} />}
          />
        </Switch>
      </div>
    </div>
  );
};

export default Pay;
